import { memo, type ReactNode } from 'react';

import {
  SideNavTrayListItemActions,
  SideNavTrayListItemBody,
  SideNavTrayListItemContent,
  SideNavTrayListItemRoot,
  SideNavTrayListItemStatus,
  SideNavTrayListItemTitle,
} from '~/components/v2/components/workspace/main-side-nav/SideNavTrayListItem';
import { WorkspaceUploadsListItemThumbnail } from '~/components/v2/components/workspace/workspace-uploads/WorkspaceUploadsListItemThumbnail';

export type WorkspaceUploadsListItemProps = {
  actions?: ReactNode;
  dimmed?: boolean;
  ext: string;
  statusCopy: string;
  thumbnailSource: string | undefined;
  title: string;
  uploadId: string;
};

export const WorkspaceUploadsListItem = memo(
  ({ actions, dimmed = false, ext, statusCopy, thumbnailSource, title, uploadId }: WorkspaceUploadsListItemProps) => (
    <SideNavTrayListItemRoot data-upload-id={uploadId} testId="WORKSPACE_UPLOADS_ITEM">
      <SideNavTrayListItemContent dimmed={dimmed}>
        <WorkspaceUploadsListItemThumbnail ext={ext} thumbnailSource={thumbnailSource} />
        <SideNavTrayListItemBody>
          <SideNavTrayListItemTitle testId="WORKSPACE_UPLOADS_ITEM_TITLE">{title}</SideNavTrayListItemTitle>
          <SideNavTrayListItemStatus testId="WORKSPACE_UPLOADS_ITEM_STATUS">{statusCopy}</SideNavTrayListItemStatus>
        </SideNavTrayListItemBody>
      </SideNavTrayListItemContent>
      {actions ? <SideNavTrayListItemActions>{actions}</SideNavTrayListItemActions> : null}
    </SideNavTrayListItemRoot>
  ),
);

WorkspaceUploadsListItem.displayName = 'WorkspaceUploadsListItem';
